var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ai-copilot", attrs: { id: "ai-copilot" } },
    [
      _c("RadialMenu", {
        attrs: { "menu-items": _vm.items, size: 450, loading: _vm.isLoading },
        on: { close: _vm.closeRadialMenu, clicked: _vm.radialMenuClicked },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }